import React from 'react';
import {StyleSheet} from 'react-native';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {BasicForm} from './forms/BasicForm';
import {useSalesmanContext} from '../../../../../../context/salesman';
import {ISalesmanClient} from '../../../../../../interfaces/dtos';
import {StackParamList} from '../../../../../../navigators';
import InternalTemplate from '../../../../../../components/templates/internal';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'AddClientStep1Screen'
>;

export const AddClientStep1Screen = ({navigation}: ScreenProps) => {
  const {setSalesmanNewClientRequest, customerTypes, salesTerritories} =
    useSalesmanContext();

  const handleGoBack = () => {
    navigation.pop(1);
  };

  const handleOnSubmit = async (data: ISalesmanClient) => {
    setSalesmanNewClientRequest(data);
    navigation.navigate('AddClientStep2Screen');
    return true;
  };

  return (
    <InternalTemplate
      title={'salesman-add-client-step1-title'}
      childContainerStyle={styles.childContainerStyle}
      backButton={{
        label: 'back-dashboard',
        onPress: () => handleGoBack(),
        usage: 'external',
      }}>
      <BasicForm
        onSubmit={handleOnSubmit}
        {...{customerTypes, salesTerritories}}
      />
    </InternalTemplate>
  );
};

const styles = StyleSheet.create({
  childContainerStyle: {
    paddingBottom: '100%',
  },
});
